import { Expose, Transform } from 'class-transformer';

import { EnumEntity } from './EnumEntity';
import { parseApiDate } from './apiDate';

export class Order {
  readonly id!: number;
  readonly medicine_count!: number;
  readonly price!: number;
  readonly status!: EnumEntity;

  /** Дата создания заказа (если приходит в списке заказов). */
  @Expose({ name: 'create_date' })
  @Transform(({ value }) => parseApiDate(value), { toClassOnly: true })
  readonly create_date?: Date;

  @Transform(({ value }) => parseApiDate(value) as Date, { toClassOnly: true })
  readonly status_date!: Date;

  /** Ссылка на оплату заказа (ЮKassa). null, если ссылка ещё не сформирована. */
  @Expose({ name: 'payment_link' })
  readonly payment_link!: string | null;

  /** Стоимость доставки (из API формы одного заказа). */
  @Expose({ name: 'delivery_price' })
  readonly delivery_price?: number;

  /** Сумма НДС (из API формы одного заказа). */
  @Expose({ name: 'vat_amount' })
  readonly vat_amount?: number;

  /** Итоговая сумма заказа (из API формы одного заказа). */
  @Expose({ name: 'total_price' })
  readonly total_price?: number;

  /** Сборка / упаковка заказа (package_fee в API). */
  @Expose({ name: 'package_fee' })
  readonly package_fee?: number;
}
